<template>
  <sgdf-responsive-header
    :username="user ? getFullName(user) : ''"
    :can-search.camel="canViewMeetingParticipant"
    :has-search.camel="!!meetingId"
    :image-url.camel="user?.avatar_url"
    mode="compact"
  >
    <img slot="logo" src="@/assets/images/logo-sgdf-symbole.png" alt="logo" />

    <template v-if="isInsideMeeting">
      <NuxtLink :to="RouteUtils.getMeetingHome(meetingId!)">
        <sgdf-navbar-item>
          <sgdf-icon name="house-chimney" style="--icon-size: 1.5em" />
        </sgdf-navbar-item>
      </NuxtLink>
      <NuxtLink
        v-if="
          hasPermission('view_public_event', meetingId) &&
          hasModule('event', meetingId)
        "
        :to="
          hasPermission('view_event', meetingId)
            ? RouteUtils.getMeetingScheduleForFormers(meetingId!)
            : RouteUtils.getMeetingSchedule(meetingId!)
        "
      >
        <sl-tooltip content="Planning de l'action de formation">
          <sgdf-navbar-item>
            {{ $t("label.schedule") }}
          </sgdf-navbar-item>
        </sl-tooltip>
      </NuxtLink>
      <NuxtLink
        v-if="
          hasPermission('view_dailytask', meetingId) &&
          hasModule('dailytask', meetingId)
        "
        :to="RouteUtils.getDailyTasks(meetingId!)"
      >
        <sl-tooltip content="Services des prochains jours">
          <sgdf-navbar-item>
            {{ $t("label.daily_task") }}
          </sgdf-navbar-item>
        </sl-tooltip>
      </NuxtLink>
      <NuxtLink
        v-if="
          hasPermission('view_public_resource', meetingId) &&
          hasModule('resource', meetingId)
        "
        :to="RouteUtils.getMeetingLinks(meetingId!)"
      >
        <sl-tooltip content="Base de connaissance">
          <sgdf-navbar-item>
            {{ $t("label.links") }}
          </sgdf-navbar-item>
        </sl-tooltip>
      </NuxtLink>
      <NuxtLink
        v-if="
          hasPermission('view_team', meetingId) &&
          hasModule('team', meetingId)
        "
        :to="RouteUtils.getMeetingTeams(meetingId!)"
      >
        <sl-tooltip
          content="Équipes du stage (équipes de vie et groupes de travail)"
        >
          <sgdf-navbar-item>
            {{ $t("label.teams") }}
          </sgdf-navbar-item>
        </sl-tooltip>
      </NuxtLink>
      <NuxtLink
        v-if="canViewMeetingParticipant"
        :to="RouteUtils.getMeetingParticipants(meetingId!)"
      >
        <sl-tooltip content="Liste des stagiaires et leurs observations">
          <sgdf-navbar-item>
            {{ $t("label.interns") }}
          </sgdf-navbar-item>
        </sl-tooltip>
      </NuxtLink>
      <NuxtLink
        v-if="canViewMeetingParticipant && needCheckIn"
        :to="`${RouteUtils.getMeetingCheckIn(meetingId!)}`"
      >
        <sl-tooltip
          content="Émargement des stagiaires - disparaît quand tous les émargements ont été effectués"
        >
          <sgdf-navbar-item>
            {{ $t("label.check-in") }}
          </sgdf-navbar-item>
        </sl-tooltip>
      </NuxtLink>
      <NuxtLink
        v-if="
          hasPermission('view_public_meetingform', meetingId) &&
          hasModule('form', meetingId)
        "
        :to="RouteUtils.getMeetingForms(meetingId!)"
      >
        <sgdf-navbar-item>
          {{ $t("label.forms") }}
        </sgdf-navbar-item>
      </NuxtLink>
      <NuxtLink
        v-if="hasModule('modularity', meetingId)"
        :to="RouteUtils.getModularEventsRegistration(meetingId!)"
      >
        <sgdf-navbar-item>
          {{ $t("label.modularity-registration") }}
        </sgdf-navbar-item>
      </NuxtLink>
      <NuxtLink
        v-if="hasPermission('change_meeting', meetingId)"
        :to="RouteUtils.getMeetingParameters(meetingId!)"
      >
        <sl-tooltip content="Edition et paramétrage du stage">
          <sgdf-navbar-item>
            {{ $t("label.parameters") }}
          </sgdf-navbar-item>
        </sl-tooltip>
      </NuxtLink>
    </template>
    <template v-else>
      <NuxtLink :to="RouteUtils.home">
        <sgdf-navbar-item>
          {{ $t("title.meetings.my") }}
        </sgdf-navbar-item>
      </NuxtLink>
      <NuxtLink
        v-if="hasPermission('view_all_meeting')"
        :to="RouteUtils.gestionnaire"
      >
        <sgdf-navbar-item>
          {{ $t("title.meetings.gest") }}
        </sgdf-navbar-item>
      </NuxtLink>
      <NuxtLink
        v-if="hasPermission('view_scope_meeting')"
        :to="RouteUtils.gestionnaireMyScope"
      >
        <sgdf-navbar-item>
          {{ $t("title.meetings.my-scope") }}
        </sgdf-navbar-item>
      </NuxtLink>
      <NuxtLink
        v-if="
          hasPermission('view_all_meeting') ||
          hasPermission('view_scope_meeting')
        "
        :to="RouteUtils.gestionnaireOngoing"
      >
        <sgdf-navbar-item>
          {{ $t("title.meetings.ongoing") }}
        </sgdf-navbar-item>
      </NuxtLink>
      <NuxtLink
        v-if="hasPermission('view_scope_meeting')"
        :to="RouteUtils.getMeetingGestionnaireOpinionReview()"
      >
        <sgdf-navbar-item>
          {{ $t("title.meetings.opinion-review") }}
        </sgdf-navbar-item>
      </NuxtLink>
      <NuxtLink
        v-if="hasPermission('view_across_meetingparticipant')"
        :to="RouteUtils.getGestionnaireParticipantsExport()"
      >
        <sgdf-navbar-item>
          {{ $t("title.export.participants") }}
        </sgdf-navbar-item>
      </NuxtLink>
    </template>
    <sl-menu slot="user-menu">
      <sl-menu-item @click="myDetails">{{
        $t("label.my-details")
      }}</sl-menu-item>
      <sl-menu-item v-if="hasPermission('change_activity', meetingId)" @click="deontologie">{{
        $t("label.deontologie")
      }}</sl-menu-item>
      <sl-menu-item @click="swapstage">{{
        $t("label.stage.swap")
      }}</sl-menu-item>
      <NuxtLink
        v-if="hasPermission('view_all_meeting')"
        :to="RouteUtils.gestionnaire"
      >
        <sl-menu-item>
          {{ $t("title.meetings.gest") }}
        </sl-menu-item>
      </NuxtLink>
      <NuxtLink
        v-if="hasPermission('view_scope_meeting')"
        :to="RouteUtils.gestionnaireMyScope"
      >
        <sl-menu-item>
          {{ $t("title.meetings.my-scope") }}
        </sl-menu-item>
      </NuxtLink>
      <NuxtLink
        v-if="
          hasPermission('view_all_meeting') ||
          hasPermission('view_scope_meeting')
        "
        :to="RouteUtils.gestionnaireOngoing"
      >
        <sl-menu-item>
          {{ $t("title.meetings.ongoing") }}
        </sl-menu-item>
      </NuxtLink>
      <NuxtLink
        v-if="hasPermission('view_scope_meeting')"
        :to="RouteUtils.getMeetingGestionnaireOpinionReview()"
      >
        <sl-menu-item>
          {{ $t("title.meetings.opinion-review") }}
        </sl-menu-item>
      </NuxtLink>
      <NuxtLink
        v-if="hasPermission('view_across_meetingparticipant')"
        :to="RouteUtils.getGestionnaireParticipantsExport()"
      >
        <sl-menu-item>
          {{ $t("title.export.participants") }}
        </sl-menu-item>
      </NuxtLink>
      <NuxtLink :to="RouteUtils.changelog">
        <sl-menu-item>
          {{ $t("title.changelog") }}
        </sl-menu-item>
      </NuxtLink>
      <sl-menu-item primary @click="logout">{{
        $t("label.logout")
      }}</sl-menu-item>
    </sl-menu>
    <sgdf-entities-search
      v-if="
        meetingId &&
        !(isDailyTaskTeamLoading && isParticipantLoading && isTeamsLoading) &&
        canViewMeetingParticipant
      "
      slot="search"
      :participants="participants"
      :teams="teams?.items ?? []"
      :daily-task-teams.camel="dailyTaskTeams?.items ?? []"
      @sgdf-select-entity="select"
    />
  </sgdf-responsive-header>
</template>

<script lang="ts" setup>
import "@sgdf/ui-library/sgdf-responsive-header.js";
import "@sgdf/ui-library/sgdf-entities-search.js";
import "@sgdf/ui-library/sgdf-navbar-item.js";
import { getFullName } from "@sgdf/ui-library/helpers/nameHelpers.js";
import "@shoelace-style/shoelace/dist/components/menu/menu.js";
import "@shoelace-style/shoelace/dist/components/menu-item/menu-item.js";
import { authenticationService } from "../core/services";
import { useQueryClient } from "@tanstack/vue-query";

const title = "Digiform";
useHeadSafe({
  titleTemplate: (pageTitle) => {
    return pageTitle ? `${pageTitle} | ${title}` : `${title}`;
  },
});

const { data: user } = useMeDetails();
const queryClient = useQueryClient();

const hasPermission = usePermission();
const hasModule = useModule();

const userStore = useUserStore();

const meetingId = useMeetingId();

const select = useNavigateToEntity();

const { data: participants, isLoading: isParticipantLoading } =
  useParticipants();
const { data: teams, isLoading: isTeamsLoading } = useTeams();
const { data: dailyTaskTeams, isLoading: isDailyTaskTeamLoading } =
  useDailyTaskTeams();

const route = useRoute();
const isInsideMeeting = computed(() => route.path.includes("/stages/"));
const needCheckIn = computed(() => {
  return (
    participants?.value?.some((p) => !p.signature_available && !p.hidden) || false
  );
});

const canViewMeetingParticipant = computed(() => {
  return hasPermission.value("view_meetingparticipant", meetingId.value);
});

async function logout() {
  authenticationService.logout(meetingId.value ?? undefined);
  userStore.$reset();
  queryClient.clear();
  await navigateTo(RouteUtils.login);
}

async function swapstage() {
  localStorage.removeItem("current_meeting");
  await navigateTo(RouteUtils.home);
}

async function deontologie() {
  await navigateTo(RouteUtils.deontology);
}

async function myDetails() {
  await navigateTo(RouteUtils.getMyDetails(meetingId.value!));
}
</script>

<style scoped>
img {
  max-height: 100%;
  max-width: 160px;
  padding: 13px 5px 13px 13px;
  width: auto;
}
</style>
